<template>
  <div
    ref="sticky"
    :style="{height: height}"
  >
    <div
      :class="{'Affix-fixed':isSticky}"
      :style="{top: offset+'px', width: width}"
    >
      <slot :isSticky="isSticky" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Affix',
  props: {
    scrollBox: [String, Element],
    offset: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      initTimes: 0,
      width: 'auto',
      height: 'auto',
      isSticky: false
    }
  },
  mounted () {
    document.addEventListener('scroll', this.onScroll)
    this.$nextTick(() => {
      this.onScroll()
    })
  },
  beforeDestroy () {
    document.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll () {
      const elSticky = this.$refs.sticky
      const isSticky = elSticky.getBoundingClientRect().top - this.offset <= 0
      if (isSticky) {
        this.width = elSticky.offsetWidth + 'px'
        this.height = elSticky.offsetHeight + 'px'
      } else {
        this.width = 'auto'
        this.height = 'auto'
      }
      this.isSticky = isSticky
    }
  }
}
</script>

<style lang="postcss">
  .Affix {
    z-index: 10;
    width: 100%;
    top: 0;
  }
  .Affix-fixed {
    position: fixed;
    transform: translate3d(0, 0, 0);
    z-index: 10;
  }
</style>
